module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00404.baa21e60.jpg";